import client from "graphql/client";
import { loader } from "graphql.macro";
import disapproveInviteFunction from "./disapproveInviteFunction";
const disapproveInvite = loader("graphql/mutations/invites/disapproveInvite.graphql");

export default function disapproveInviteAction(organisationId, state) {
    return () => {
        const { inviteId, sequenceNumber } = state;
        const series = {
            id: inviteId,
            sequenceNumber: sequenceNumber + 1
        };

        return client.mutate({
            mutation: disapproveInvite,
            variables: {organisationId, series},
            update: disapproveInviteFunction(organisationId)
        });
    };
}
